import { SVGProps } from 'react';

export default function EditVerticesIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
      aria-hidden='true'
      {...props}
    >
      <rect
        x='6'
        y='6'
        width='12'
        height='12'
        rx='1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='6' cy='6' r='1.75' fill='currentColor' stroke='none' />
      <circle cx='18' cy='6' r='1.75' fill='currentColor' stroke='none' />
      <circle cx='6' cy='18' r='1.75' fill='currentColor' stroke='none' />
      <circle cx='18' cy='18' r='1.75' fill='currentColor' stroke='none' />
    </svg>
  );
}
